import Cookie from 'js-cookie';
import jwtDecode from 'jwt-decode';

import { redirectWithPrefix } from './helper';
import VoltranGwService from '../service/VoltranGwService';

const ApplicationKeys = {
  MobileIphone: 'BF448871-DB72-4CD7-A0E0-1F82BF410370',
  MobileAndroid: '8093F525-1BAC-49C0-8FB7-C9F7B2DA04CF',
  WebSite: 'AF7F2A37-CC4B-4F1C-87FD-FF3642F67ECB',
  MobileSite: 'D5BABFEB-AEE3-420B-9857-0697C8716A7E',
  MobileIpad: '8B497575-C938-4807-8060-130380F67F7C',
  BackOffice: 'DACEEFC8-68BC-40FB-B693-BC7198F42474',
  LegacyMobileApp: 'A0A16B0C-9FCE-48BB-8881-4AC263A938F3',
  KanalD: '71C6ED59-AA28-4852-8C7B-3FE28480E7EC'
};

const applicationType = key => {
  if (
    key === ApplicationKeys.MobileIphone ||
    key === ApplicationKeys.MobileIpad ||
    key === ApplicationKeys.MobileAndroid ||
    key === ApplicationKeys.LegacyMobileApp
  ) {
    return 'Mobile';
  }
  return 'Site';
};

export const getUserInfo = () => {
  return Cookie.get('userInfo');
};

const getCustomer = async () => {
  const jwtCookie = getUserJWT();
  let customer = null;
  if (jwtCookie) {
    const jwtInfo = jwtDecode(jwtCookie);
    if (jwtInfo) {
      customer = {
        ...jwtInfo,
        Application: applicationType(jwtInfo.AppKey)
      };
    }
    return customer;
  }

  const userInfoData = getUserInfo();
  if (userInfoData) {
    const userInfo = JSON.parse(userInfoData);
    const customerAppKey = userInfo.ak?.toUpperCase();
    customer = {
      ...userInfo,
      AppKey: customerAppKey,
      Application: applicationType(customerAppKey),
      Title: userInfo?.t,
      UserId: userInfo?.uid,
      Email: userInfo?.e,
      IsAuthenticated: userInfo?.exp ? 'True' : 'False',
      Gsm: userInfo?.g
    };
    return customer;
  }

  const response = await VoltranGwService.validateJwt();
  if (
    response.status === 200 &&
    response?.data?.token !== null &&
    response?.data?.token.IsAuthenticated
  ) {
    customer = {
      ...response.data.token,
      Application: applicationType(response.data.token.AppKey)
    };
  }
  return customer;
};

const isValidUser = customerData => {
  const customer = customerData || getUserInfoFromCookie();
  if (!customer) {
    return false;
  }
  if (typeof customer?.IsAuthenticated === 'string' && customer?.IsAuthenticated === 'True') {
    return true;
  }

  if (customer?.exp && new Date(customer.exp * 1000) >= new Date()) {
    return true;
  }

  return false;
};

const redirectWithPrefixIfUserNotValid = (prefix = '') => {
  const customerData = getUserInfoFromCookie();
  if (!isValidUser(customerData)) {
    redirectWithPrefix(prefix);
    return false;
  }
  return true;
};

export const isBrowser = () => {
  return process.env.BROWSER && window;
};

export const isMobileDevice = () =>
  isBrowser() &&
  (typeof window?.orientation !== 'undefined' || /Mobi/.test(window?.navigator?.userAgent));

export const isIOSWebview =
  isBrowser() && /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);

export const isAndroidWebview = isBrowser() && typeof window.Android !== 'undefined';

export const isAppWebview = isIOSWebview || isAndroidWebview;

const getSiteType = () => {
  if (isMobileDevice()) {
    if (isAndroidWebview) {
      return 'android_native';
    }
    if (isIOSWebview) {
      return 'ios_native';
    }
    return 'mobile';
  }
  return 'desktop';
};

const getUserJWT = () => {
  return Cookie.get('jwt');
};

const getCustomerJWT = () => {
  const jwtCookie = getUserJWT();
  if (!jwtCookie) {
    return false;
  }
  let customer = null;

  const jwtInfo = jwtDecode(jwtCookie);

  if (jwtInfo) {
    customer = {
      ...jwtInfo,
      Application: applicationType(jwtInfo.AppKey)
    };
  }

  return customer;
};

const getUserInfoFromCookie = () => {
  const customer =
    getCustomerJWT() || (Cookie.get('userInfo') ? JSON.parse(Cookie.get('userInfo')) : null);
  return customer
    ? {
        UserId: customer?.UserId || customer?.uid,
        Title: customer?.Title || customer?.t,
        FirstName: customer?.FirstName || customer?.fn,
        LastName: customer?.LastName || customer?.ln,
        Email: customer?.Email || customer?.e,
        AppKey: customer?.AppKey || customer?.ak,
        ...customer
      }
    : null;
};

export {
  applicationType,
  getCustomer,
  getUserInfoFromCookie,
  isValidUser,
  redirectWithPrefixIfUserNotValid,
  getSiteType
};
